import { UserPreferenceAssetResponse } from "../@types/UserPreferences";
import { destroy, store } from "../services/user/preferences/assets";

export default function useUserPreferences() {
  function addAsset(
    encodedId: string
  ): Promise<UserPreferenceAssetResponse | null> {
    return store(encodedId);
  }

  function removeAsset(
    encodedId: string
  ): Promise<UserPreferenceAssetResponse | null> {
    return destroy(encodedId);
  }

  return { addAsset, removeAsset };
}
